import * as React from 'react';

import { Collapse } from '../../components/Collapse';
import { ECollapseBlockType, trackCollapseBlockClose, trackCollapseBlockShow } from './tracking';

export interface ICollapsed {
  header: string;
  headerClassName?: string;
  collapsed: boolean;
  blockType: ECollapseBlockType;
}

export const CollapseContainer = ({
  header,
  headerClassName,
  blockType,
  children,
  collapsed,
}: React.PropsWithChildren<ICollapsed>) => {
  const [isCollapsed, setIsCollapsed] = React.useState(collapsed);

  const onClick = React.useCallback(() => {
    if (isCollapsed) {
      trackCollapseBlockShow(blockType);
    } else {
      trackCollapseBlockClose(blockType);
    }
    setIsCollapsed(!isCollapsed);
  }, [blockType, isCollapsed]);

  return (
    <Collapse isCollapsed={isCollapsed} onClick={onClick} header={header} headerClassName={headerClassName}>
      {children}
    </Collapse>
  );
};
